import { render, staticRenderFns } from "./subLocationsTable.vue?vue&type=template&id=2705aa10"
import script from "./subLocationsTable.vue?vue&type=script&lang=js"
export * from "./subLocationsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports